"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_spinner_material_1 = __importDefault(require("react-spinner-material"));
var react_1 = __importDefault(require("react"));
var colors_1 = require("../util/colors");
var grid_1 = require("./grid");
var Loading = function (_a) {
    var _b = _a.py, py = _b === void 0 ? 2 : _b, options = __rest(_a, ["py"]);
    var spinnerProps = __assign({ radius: 120, color: colors_1.colors.primary700, stroke: 2, visible: true }, options);
    return (react_1.default.createElement(grid_1.Container, { py: py, center: true },
        react_1.default.createElement(react_spinner_material_1.default, __assign({}, spinnerProps))));
};
exports.default = Loading;
//# sourceMappingURL=Loading.js.map